<template>
  <div>
    <v-dialog v-model="dialog" max-width="420">
      <v-card class="user-account-password-dialog">
        <v-form @submit.prevent="onSubmit">
          <v-card-title class="text-h6 font-weight-bold pt-5 px-6">
            {{ $t("settings.profile.password.dialogTitle") }}
          </v-card-title>
          <v-card-text class="px-6 pt-2 pb-0">
            <v-alert
              v-if="errorMessage"
              type="error"
              class="mb-4"
              density="compact"
            >
              {{ errorMessage }}
            </v-alert>
            <v-text-field
              v-model="form.newPassword"
              :label="$t('settings.profile.password.new')"
              :type="showPasswords ? 'text' : 'password'"
              :append-inner-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
              autocomplete="new-password"
              required
              class="mb-2"
              @click:append-inner="toggleVisibility"
            />
            <v-text-field
              v-model="form.confirmPassword"
              :label="$t('settings.profile.password.confirm')"
              :type="showPasswords ? 'text' : 'password'"
              :append-inner-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
              autocomplete="new-password"
              required
              @click:append-inner="toggleVisibility"
            />
          </v-card-text>
          <v-card-actions class="px-6 pb-5 pt-2 ga-2 justify-end">
            <v-btn variant="text" @click="close">
              {{ $t("settings.profile.actions.cancel") }}
            </v-btn>
            <v-btn color="primary" type="submit" :loading="loading">
              {{ $t("settings.profile.actions.save") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="successSnackbar" color="success" :timeout="3200">
      {{ $t("settings.profile.messages.changePasswordSuccess") }}
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { validatePasswordChange } from "@/components/userAccount/utils.mjs";

export default {
  name: "UserAccountPasswordDialog",
  props: {
    modelValue: { type: Boolean, default: false },
    userId: { type: [Number, String], default: null },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      form: { newPassword: "", confirmPassword: "" },
      showPasswords: false,
      loading: false,
      errorMessage: "",
      successSnackbar: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.form = { newPassword: "", confirmPassword: "" };
        this.errorMessage = "";
      }
    },
  },
  methods: {
    toggleVisibility() {
      this.showPasswords = !this.showPasswords;
    },
    close() {
      this.dialog = false;
    },
    async onSubmit() {
      if (!this.userId) {
        this.errorMessage = this.$t("settings.profile.messages.missingUser");
        return;
      }
      const { newPassword, confirmPassword } = this.form;
      const validationError = validatePasswordChange({ newPassword, confirmPassword });
      if (validationError) {
        this.errorMessage = validationError;
        return;
      }
      this.loading = true;
      this.errorMessage = "";
      try {
        await axios.put("/users/me/password", { password: newPassword });
        this.successSnackbar = true;
        this.close();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Eroare la schimbarea parolei:", error);
        this.errorMessage = this.$t("settings.profile.messages.changePasswordError");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
